export const iconFontAwesomeSecurityFileSignature = (
	<i className="fa-solid fa-file-signature"></i>
);
